import DeviceIcon from '@/legacy/components/ui/Icons/DeviceIcon';

import { paths } from '../router/path';
import { AppNavNode } from './types';
import { Gift, PremiumIcon } from '@/legacy/components/ui/Icons';
import { Coins, Tools, UsersIcon } from '@/shared/ui/icons';
import { i18nKeys } from '@/shared/i18n';
import { PERMISSIONS } from '@/shared/constants';
import HomeIcon from '@/legacy/components/ui/Icons/HomeIcon';
import { TFunction } from 'i18next';

export const getMainNav = (t: TFunction): AppNavNode[] => [
	{
		type: 'link',
		text: t(i18nKeys.nav.home),
		to: paths.home(),
		icon: <HomeIcon />,
		useIndicator: false,
	},
	{
		type: 'group',
		text: t(i18nKeys.nav.frekuentSpots.group),
		icon: <DeviceIcon />,
		children: [
			{
				type: 'link',
				text: t(i18nKeys.nav.frekuentSpots.pointsOfSale),
				to: paths.frekuentSpots.list(),
				requiredPermission: [PERMISSIONS.MACHINE_READ],
			},
			// {
			// 	type: 'link',
			// 	text: t(i18nKeys.nav.frekuentSpots.personalization),
			// 	to: paths.frekuentSpots.posPersonalization.base(),
			// 	icon: <PremiumIcon />,
			// 	tone: 'premium',
			// 	requiredPermission: [PERMISSIONS.POS_PERSONALIZATION_READ],
			// 	requiredBuyPermission: PERMISSIONS.POS_PERSONALIZATION_BUY,
			// 	requiredPermissionMode: 'role-only',
			// },
			{
				type: 'link',
				text: t(i18nKeys.nav.frekuentSpots.products),
				to: paths.frekuentSpots.products(),
				requiredPermission: [PERMISSIONS.PRODUCT_READ],
			},
		],
	},
	{
		type: 'group',
		text: t(i18nKeys.nav.users.group),
		icon: <UsersIcon />,
		children: [
			{
				type: 'link',
				text: t(i18nKeys.nav.users.appUsers),
				to: paths.users.users.list(),
				requiredPermission: [PERMISSIONS.USER_READ],
			},
			{
				type: 'link',
				text: t(i18nKeys.nav.users.nfcTags),
				to: paths.users.tagsNfc.base(),
				requiredPermission: [PERMISSIONS.TAG_READ],
			},
			{
				type: 'link',
				text: t('endUsers:qrs.title'),
				to: paths.users.qrs.base(),
				requiredPermission: [PERMISSIONS.QR_READ],
			},
			{
				type: 'link',
				text: t(i18nKeys.nav.users.userSupport),
				to: paths.users.support.list(),
				requiredPermission: [PERMISSIONS.TICKET_READ],
			},
		],
	},
	{
		type: 'group',
		text: t(i18nKeys.nav.benefits.group),
		icon: <Gift />,
		children: [
			{
				type: 'link',
				text: t(i18nKeys.nav.benefits.promotions),
				to: paths.benefits.promotions.list(),
				requiredPermission: [PERMISSIONS.PROMOTION_READ],
			},
			{
				type: 'link',
				text: t(i18nKeys.nav.benefits.packs),
				to: paths.benefits.packs.list(),
				requiredPermission: [PERMISSIONS.PROMOTION_READ],
			},
		],
	},
	{
		type: 'group',
		text: t(i18nKeys.nav.finance.group),
		icon: <Coins />,
		children: [
			{
				type: 'link',
				text: t(i18nKeys.nav.finance.reconciliations),
				to: paths.finance.reconciliations.list(),
				tone: 'premium',
				icon: <PremiumIcon />,
				requiredPermission: [PERMISSIONS.CONCILIATION_READ],
				requiredPermissionMode: 'role-only',
				requiredBuyPermission: PERMISSIONS.CONCILIATION_BUY,
			},
		],
	},
	{
		type: 'group',
		text: t(i18nKeys.nav.tools.group),
		icon: <Tools />,
		children: [
			{
				type: 'link',
				text: t(i18nKeys.nav.tools.reports),
				to: paths.tools.reports.base(),
				requiredPermission: [PERMISSIONS.REPORT_READ],
			},
			{
				type: 'link',
				text: t(i18nKeys.nav.tools.alerts),
				to: paths.tools.alerts.base(),
				tone: 'premium',
				icon: <PremiumIcon />,
				requiredBuyPermission: PERMISSIONS.ALERTS_BUY,
			},
		],
	},
];
